import { render, staticRenderFns } from "./List-Invoice-COD-branch.vue?vue&type=template&id=b0f18bcc&scoped=true"
import script from "./List-Invoice-COD-branch.vue?vue&type=script&lang=js"
export * from "./List-Invoice-COD-branch.vue?vue&type=script&lang=js"
import style0 from "./List-Invoice-COD-branch.vue?vue&type=style&index=0&id=b0f18bcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f18bcc",
  null
  
)

export default component.exports